module.exports = __webpack_public_path__ + "static/media/S1-2-Zagoc-cod2.f1cd8166.png";